import MyAccountContainer from "components/Console/MyAccount/MyAccount.container";

const MyAccountPage = () => {
  return <MyAccountContainer />;
};

export default MyAccountPage;
